export type TokenExchangeInstance = 'eu' | 'us' | 'us-demo' | 'us-uat';

/**
 * Resolves the Firebase instance (`eu`/`us`/`us-demo`/`us-uat`) sent to the Identity Token
 * Exchange service. Throws a `token exchange`-classified error when the
 * environment is misconfigured so the existing AuthErrorPage path renders.
 */
export function getTokenExchangeInstance(): TokenExchangeInstance {
  // Annotate as string | undefined: the env var is typed as a literal union,
  // which would otherwise make the runtime guard look unreachable to TS.
  const value: string | undefined = import.meta.env
    .PUBLIC_IDENTITY_TOKEN_EXCHANGE_INSTANCE;

  if (
    value !== 'eu' &&
    value !== 'us' &&
    value !== 'us-demo' &&
    value !== 'us-uat'
  ) {
    throw new Error(
      `Token exchange instance misconfigured: PUBLIC_IDENTITY_TOKEN_EXCHANGE_INSTANCE must be "eu", "us", "us-demo", or "us-uat", got "${value}"`
    );
  }

  return value;
}
